export default "__VITE_ASSET__elYePaCu__"